export default "__VITE_ASSET__56ee662d__"